import React from 'react';
import { useSelector } from 'react-redux';

import { ErrorContainer, ErrorMessageWrapper, ErrorHeader, ErrorText } from './response-error.styled';
import ErrorImage from './error-image';

const SubmissionStartError = () => {
  const { notFoundText } = useSelector((state) => state.form);
  
  return (
    <ErrorMessageWrapper>
      <ErrorContainer>
        <ErrorImage />
        <ErrorHeader>Form Opens Soon!</ErrorHeader>
        <ErrorText>
          <p>{notFoundText}</p>
        </ErrorText>
      </ErrorContainer>
    </ErrorMessageWrapper>
  );
};

export default SubmissionStartError;
